module.exports = {"de":{"closed":"Abgeschlossen","open":"Offen","pending":"in Arbeit"}}


//////////////////
// WEBPACK FOOTER
// ./~/simpl-i18n/locales/notifications/projectStatus.json
// module id = 1398
// module chunks = 1